import styled from "styled-components";
interface StyleProps {
  isActive?: boolean;
}

export const Tabs = styled.div.attrs({
  // className: "mt-4",
})`
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid #e4e4e7;
`;

export const Tab = styled.button<StyleProps>`
  background-color: transparent;
  border: 0;
  padding: 1rem;
  border-bottom: 6px ${(props: any) => props.isActive && "solid #B580FF;"};
  border-top: 1px
    ${(props: any) => props.isActive && "solid rgba(161, 161, 170, 1);"};
  border-right: 1px
    ${(props: any) => props.isActive && "solid rgba(161, 161, 170, 1);"};
  border-left: 1px
    ${(props: any) => props.isActive && "solid rgba(161, 161, 170, 1);"};
  transition: all ease-in-out 0.3s;
  width: 120px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    padding-right: 0.7rem;
    padding-left: 0.7rem;
  }
  height: 40px;
`;

export const BigBoldText = styled.span.attrs({
  className: "text-2xl",
})`
  font-weight: 700;
  color: var(--dark);
`;
// ${(props: any) => props.isActive && "};
